declare var window: any;
import { ClassTransformOptions, Type, plainToClass } from 'class-transformer';
import Model from './Model';
import FeedbackResponse from './FeedbackResponse';

class Feedback extends Model {

    id: number;
    subject_id: number;
    subject_type: string;
    responder_id: number;
    responder_type: string;

    comment: string;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Feedback';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => FeedbackResponse)
    feedback_responses: FeedbackResponse[];


    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    

    
    /**
     * Check for comment
     *
     * @return {boolean}
     */
    hasComment() {
        return this.comment && !!this.comment.trim().length;
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): Feedback[];
    static new(plain: {}, options?: ClassTransformOptions): Feedback;
    static new(plain: {} | [], options?: ClassTransformOptions): Feedback | Feedback[] {
        return plainToClass(Feedback, plain as any, options);
    }
}

export default Feedback;
